import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import { ReadLocationsRequestDto, ReadLocationsResponseDto } from "./dtos";
import { qs } from "../../../../utils";

export const listLocations = async (
  { _query }: ReadLocationsRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReadLocationsResponseDto>> => {
  const query = qs.stringify(_query);
  return await http.get<ReadLocationsResponseDto>(`/locations${query}`, {
    cancelToken,
  });
};
